import { useEffect } from 'react'
import getConfig from 'next/config'
import Pusher from 'pusher-js'
import { onNewPrintJob } from './hwConnect'

const { publicRuntimeConfig } = getConfig()
const { restApiUrl } = publicRuntimeConfig

const PUSHER_APP_KEY = 'c75206540d6cba578600'
const PUSHER_CLUSTER = 'us2'
const PUSHER_AUTH_ENDPOINT = restApiUrl
  ? `${restApiUrl}/auth/pusher`
  : 'https://app-endpoints.shiphero.com/auth/pusher'

/**
 * A hook that connects to a Pusher channel and subscribes to
 * member events.
 *
 * It returns the list of online computer, identified by their hash.
 */
const usePusher = (
  computer,
  ipc,
  token,
  metadata = {},
  refreshToken = () => {},
) => {
  const accountId = computer?.account_id
  const metadataStr = JSON.stringify(metadata)
  useEffect(() => {
    if (!accountId || !token) return

    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: PUSHER_CLUSTER,
      authEndpoint: PUSHER_AUTH_ENDPOINT,
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { metadata: metadataStr },
      },
    })

    const channel = pusher.subscribe(`presence-${accountId}`)
    const printChannel = pusher.subscribe(`prints-${computer.row_id}`)

    const updateOnlineComputers = () => {
      const newOnlineComputer = []
      const channelMembers = channel.members && channel.members.members

      if (!channelMembers) return

      Object.keys(channelMembers).forEach(memberId => {
        const member = channelMembers[memberId]
        if (!member.metadata) return

        const onlineComputerHash = member.metadata.computer_hash

        newOnlineComputer.push(onlineComputerHash)
      })
    }

    channel.bind('pusher:subscription_succeeded', updateOnlineComputers)
    channel.bind('pusher:member_added', updateOnlineComputers)
    channel.bind('pusher:member_removed', updateOnlineComputers)
    channel.bind('pusher:subscription_error', async status => {
      refreshToken()
    })

    printChannel.bind('print-job', data => {
      console.log('Received Pusher print request')
      onNewPrintJob(computer, data, ipc)
    })

    return () => {
      if (!pusher) return

      pusher.unsubscribe(`presence-${accountId}`)
      pusher.unsubscribe(`prints-${computer.row_id}`)
      channel.unbind()
      printChannel.unbind()
    }
  }, [accountId, metadataStr, token])

  return { computerUpdated: () => {} }
}

export default usePusher
